import OrderArticle, { getTotalPrice } from "../../models/order/OrderArticle";

export default function calculateXthItemYPercentageOffCampaign(
  x: number,
  y: number,
  orderArticles: OrderArticle[],
  priceLineId: number | null,
  articleIds: { [articleId: string]: true | undefined }
) {
  let discountAmount = 0;

  orderArticles = orderArticles
    .filter((orderArticle) => articleIds[orderArticle.article.id])
    .sort(
      (a, b) =>
        getTotalPrice(a, priceLineId, { count: 1, includeOptions: false, includeExtraOrderArticles: false }) -
        getTotalPrice(b, priceLineId, { count: 1, includeOptions: false, includeExtraOrderArticles: false })
    );
  const totalCount = orderArticles.reduce((sum, orderArticle) => {
    return sum + orderArticle.count;
  }, 0);
  const numberOfDiscountedItems = Math.floor(totalCount / x);

  let numberOfItemsDiscounted = 0;
  orderArticles.some((orderArticle) => {
    if (numberOfItemsDiscounted + orderArticle.count <= numberOfDiscountedItems) {
      discountAmount +=
        (getTotalPrice(orderArticle, priceLineId, { includeOptions: false, includeExtraOrderArticles: false }) *
          (y ?? 0)) /
        100;
      numberOfItemsDiscounted += orderArticle.count;
      orderArticle.count = 0;
      return false;
    } else {
      const count = numberOfDiscountedItems - numberOfItemsDiscounted;
      discountAmount +=
        (getTotalPrice(orderArticle, priceLineId, {
          count,
          includeOptions: false,
          includeExtraOrderArticles: false,
        }) *
          (y ?? 0)) /
        100;
      numberOfItemsDiscounted += count;
      orderArticle.count -= count;
      return true;
    }
  });

  return discountAmount;
}
